// extracted by mini-css-extract-plugin
export default {"tabs":"_1wFRU","tabs__title":"_2QPar","tabs__selected":"_3Dc5D"};